import { translate as $t } from '@/assets/languages'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navList: [],
    keepAlive: [], // 动态缓存的页面name数组
    fromName: '', // 前一个页面的名字
    token: localStorage.getItem('user_token')
      ? localStorage.getItem('user_token')
      : '',
    userid: localStorage.getItem('user_id')
      ? localStorage.getItem('user_id')
      : '',
    role: null,
    user_info: localStorage.getItem('user_info')
      ? JSON.parse(localStorage.getItem('user_info'))
      : null,
    imgUrl: 'https://dqgpzkg579yd4.cloudfront.net/',
    refresh: {}, // 需要强制刷新的页面name对象
    invite: null, // 是否邀请激活
    homeConfig: localStorage.getItem('home_config')
      ? JSON.parse(localStorage.getItem('home_config'))
      : null, // 配置
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
    remTopx: (document.body.clientWidth / 100) * 26.6666,
    userPath:
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'testing'
        ? 'https://test.cc0094.com'
        : 'https://www.krazefootball.com'
  },
  mutations: {
    SET_NAV: (state, navList) => {
      state.navList = navList
    },
    SET_KEEP_ALIVE: (state, keepAlive) => {
      state.keepAlive = keepAlive
    },
    SET_FROM_NAME: (state, name) => {
      state.fromName = name
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_UID: (state, id) => {
      state.userid = id
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_USER_INFO: (state, data) => {
      state.user_info = data
    },
    LOG_OUT: (state) => {
      state.token = ''
      state.userid = ''
      state.user_info = null
    },
    SET_REFRESH: (state, data) => {
      if (data.type) {
        state.refresh[data.name] = true
      } else {
        delete state.refresh[data.name]
      }
    },
    SET_INVITE: (state, data) => {
      state.invite = data
    },
    SET_HOME_CONFIG: (state, data) => {
      state.homeConfig = data
    },
    SET_LANG: (state, data) => {
      state.lang = data
    }
  },
  actions: {
    setRole({ commit }, role = this.state.role) {
      commit('SET_ROLE', role)
      let nav, pa
      pa = '/' + role
      if (role === 'mcn') {
        nav = [
          {
            label: $t('home'),
            route: '/'
          },
          {
            label: $t('income'),
            route: pa + '/income'
          }
        ]
      }
      if (role === 'user') {
        nav = [
          {
            label: $t('home'),
            route: '/'
          },
          {
            label: $t('hotnfts'),
            route: pa + '/nftlist'
          },
          {
            label: $t('activity'),
            route: pa + '/actcategory'
          },
          {
            label: $t('account'),
            route: pa + '/account'
          },
          {
            label: $t('mintnft'),
            route: pa + '/mint'
          }
        ]
      }
      if (role === 'babe') {
        nav = [
          {
            label: $t('home'),
            route: '/'
          },
          {
            label: $t('activitypage.text24'),
            route: pa + '/activity'
          },
          {
            label: $t('wallet'),
            route: pa + '/wallet'
          }
        ]
      }
      commit('SET_NAV', nav)
    },
    setNav({ commit }, data) {
      commit('SET_NAV', data)
    },
    Login({ commit }, data) {
      localStorage.setItem('user_id', data.user_id)
      localStorage.setItem('user_token', data.user_token)
      commit('SET_TOKEN', data.user_token)
      commit('SET_UID', data.user_id)
    },
    UserInfo({ commit }, data) {
      localStorage.setItem('user_info', JSON.stringify(data))
      commit('SET_USER_INFO', data)
    },
    LogOut({ commit }) {
      localStorage.removeItem('user_id')
      localStorage.removeItem('home_config')
      localStorage.removeItem('user_info')
      localStorage.removeItem('user_token')
      localStorage.removeItem('mintinfo')
      commit('SET_KEEP_ALIVE', [])
      commit('LOG_OUT')
    },
    setRefresh({ commit }, data) {
      commit('SET_REFRESH', data)
    },
    setInvite({ commit }, data) {
      commit('SET_INVITE', data)
    },
    setHomeConfig({ commit }, data) {
      localStorage.setItem('home_config', JSON.stringify(data))
      commit('SET_HOME_CONFIG', data)
    },
    setLang({ commit }, data) {
      localStorage.setItem('lang', data)
      commit('SET_LANG', data)
    }
  },
  getters: {
    keepAlive: (state) => state.keepAlive
  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js